import styled from "@emotion/styled"

import { useConsole } from "contexts/Console"

import DownloadBrochure from "./DownloadBrochure"

const Root = styled.section`
  overflow: hidden;
`

const Banners = styled.div`
  display: grid;
`

const Slide = styled.div`
  display: grid;
  height: 40vh;
  grid-area: -1/1;
  position: relative;
`

export default function ModelDownloads(props) {
  const { model, brochure } = props
  const console = useConsole()

  console.verbose("Model:ModelDownloads(%o)", props)
  return (
    <Root>
      <Banners>
        <Slide>
          <DownloadBrochure model={model} {...brochure} />
        </Slide>
      </Banners>
    </Root>
  )
}
